import moment, { Moment } from 'moment';

export interface HallOfFamePlayerDTO {
	avatar: string | null;
	fullname: string;
}

interface HallOfFameCategoryDTO<T> {
	items: T[];
	count: number;
}

export interface HallOfFameDTO {
	date_from: string;
	date_to: string;
	players: {
		highest_win_streak: HallOfFameCategoryDTO<HallOfFamePlayerDTO & { current_win_streak: number }>;
		undefeated_champion: HallOfFameCategoryDTO<HallOfFamePlayerDTO & { win_ratio: string }>;
		marathon_runner: HallOfFameCategoryDTO<HallOfFamePlayerDTO & { battle_count: number }>;
	};
}

export interface HallOfFamePlayer {
	avatar: string | null;
	fullname: string;
}

export interface HallOfFamePlayers {
	highestWinStreak: (HallOfFamePlayer & { currentWinStreak: number }) | null;
	undefeatedChampion: (HallOfFamePlayer & { winRation: string }) | null;
	marathonRuner: (HallOfFamePlayer & { battleCount: number }) | null;
}

export default class HallOfFame {
	public readonly dateFrom: Moment;
	public readonly dateTo: Moment;
	public readonly players: HallOfFamePlayers;

	constructor(data: HallOfFameDTO) {
		this.dateFrom = moment(data.date_from);
		this.dateTo = moment(data.date_to);

		const highestWinStreak = data.players.highest_win_streak.items[0];
		const undefeatedChampion = data.players.undefeated_champion.items[0];
		const marathonRunner = data.players.marathon_runner.items[0];

		this.players = {
			highestWinStreak: highestWinStreak
				? {
						avatar: highestWinStreak.avatar,
						fullname: highestWinStreak.fullname,
						currentWinStreak: highestWinStreak.current_win_streak,
				  }
				: null,
			undefeatedChampion: undefeatedChampion
				? {
						avatar: undefeatedChampion.avatar,
						fullname: undefeatedChampion.fullname,
						winRation: undefeatedChampion.win_ratio,
				  }
				: null,
			marathonRuner: marathonRunner
				? {
						avatar: marathonRunner.avatar,
						fullname: marathonRunner.fullname,
						battleCount: marathonRunner.battle_count,
				  }
				: null,
		};
	}
}
